import { Box } from '@mui/material'
import { PhotoSliderDateText } from 'src/features/reports/result/components/reportResult/PhotoSlider/PhotoSliderDateText'
import { getFormattedRecordedAt } from 'src/util/date'
import { ClickableImage } from './ClickableImage'

type Props = {
  url: string
  recordedAt: string
}

export function LabelResultImage({ url, recordedAt }: Props) {
  return (
    <ClickableImage src={url} alt="レポートラベル画像">
      <Box sx={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
        <PhotoSliderDateText dateText={getFormattedRecordedAt(recordedAt)} />
      </Box>
    </ClickableImage>
  )
}
